import axios from "axios";

export const getSlides = async (query) => {
  const url =
    axios.getUri({ url: "/api/slides", params: query }) || `/api/slides`;

  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminGetSlide = async (query) => {
  const url =
    axios.getUri({ url: "/api/admin/slide", params: query }) ||
    `/api/admin/slide`;

  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminCreateSlide = async (formData) => {
  const url = `/api/admin/slide`;
  return axios.post(url, formData, {
    credentials: "include",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const adminUpdateSlide = async (id, data) => {
  const url = `/api/admin/slide/${id}`;
  return axios(url, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const adminDeactiveSlide = async (id) => {
  const url = `/api/admin/slide/${id}/deactive`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminActiveSlide = async (id) => {
  const url = `/api/admin/slide/${id}/active`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminDeleteSlide = async (id) => {
  const url = `/api/admin/slide/${id}`;
  return axios(url, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
